// extracted by mini-css-extract-plugin
export var rocket = "style-module--rocket--f4400";
export var targetAudience = "style-module--target-audience--c1948";
export var targetAudience__item = "style-module--target-audience__item--9db4e";
export var targetAudience__itemOne = "style-module--target-audience__item--one--3b0f8";
export var targetAudience__itemThree = "style-module--target-audience__item--three--d6b89";
export var targetAudience__itemTwo = "style-module--target-audience__item--two--a544b";
export var targetAudience__text = "style-module--target-audience__text--210d1";
export var targetAudience__title = "style-module--target-audience__title--f09e6";
export var targetAudience__wrap = "style-module--target-audience__wrap--38e4e";